import { __decorate, __metadata } from "tslib";
import { IsNumberString, IsOptional, IsString } from 'class-validator';
export class AddressLookupRequest {
    constructor(searchTerm, countryCodes, limit) {
        this.searchTerm = searchTerm;
        this.countryCodes = countryCodes;
        this.limit = limit;
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AddressLookupRequest.prototype, "searchTerm", void 0);
__decorate([
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], AddressLookupRequest.prototype, "countryCodes", void 0);
__decorate([
    IsOptional(),
    IsNumberString(),
    __metadata("design:type", Number)
], AddressLookupRequest.prototype, "limit", void 0);
